import Banner from '../components/banner.js';
import Getintouch from '../components/getintouch.js';
import Tsolutions from '../components/tsolutions.js';
import Benefits from '../components/benefits.js';
import Services from '../components/services.js';
import Loading from '../components/loading.js';

export default function Home(){
    return (
        <div>
            <Banner />
            <Benefits />
            <Loading />
            <Tsolutions />
            <Services />
            <Getintouch />
        </div>
    );
}